import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '首页', path: '/' },
    { label: '韩漫', path: '/category/hanman' },
    { label: '日漫', path: '/category/riman' },
    { label: '国漫', path: '/category/guoman' },
  ],
  热门分类: [
    { label: '热血漫画', path: '/category/rexue' },
    { label: '玄幻漫画', path: '/category/xuanhuan' },
    { label: '恋爱漫画', path: '/category/shaonv' },
    { label: '悬疑漫画', path: '/category/xuanyi' },
  ],
  关于我们: [
    { label: '品牌介绍', path: '/about' },
    { label: '联系方式', path: '/about#contact' },
    { label: '常见问题', path: '/#faq' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-book-open-line text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading text-xl font-bold text-foreground-900">
                布丁漫画
              </span>
            </Link>
            <p className="text-foreground-600 text-sm leading-relaxed">
              布丁漫画网 - 专注于下拉式连续阅读体验的漫画平台。
              韩漫、日漫、国漫大全，无需翻页，畅享完整漫画内容。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-foreground-900 font-medium text-sm mb-4">
                <a href={`#${title}`} className="hover:text-primary-500 transition-colors">{title}</a>
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-foreground-600 text-sm hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4 text-foreground-500 text-xs">
          <p>&copy; 2026 布丁漫画网 BudingManhua.com 版权所有</p>
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
            <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}